// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YYnT","label":"styles_label__30ZaG"};